export default __webpack_public_path__ + "static/media/jcb.0c0155c8.svg";